<template>
    <div class="steps-edit-header">
        <div class="component-title order-1 order-sm-0">
            <h5 class="title">
                {{$t('roadmap.steps')}}
            </h5>
        </div>
    </div>
</template>

<script>
export default {
    name: "design-2021-roadmap-step-header-component"
}
</script>

<style scoped lang="scss">
    .steps-edit-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        .component-title {
            margin-bottom: 0;
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'sm')){
        .steps-edit-header {
            .component-title {
                width: calc(100% - 55px);
            }
        }
    }
</style>
